<template>
  <div>
    <a-card :bordered="false">
      <div slot="title">
        <a-space align="center">
          <div class="title_icon"></div>
          <div class="ant-descriptions-title" style="font-size: 16px; margin-bottom: 0">
            意向发布项目
          </div>
        </a-space>
      </div>

      <div class="search-area">
        <a-form layout="inline">
          <a-form-item label="状态">
            <a-select
              v-model="queryParam.projectStatus"
              placeholder="全部"
              style="width: 160px"
              @change="onSearch"
            >
              <a-select-option
                v-for="status in dictionaries.projectStatus"
                :key="status.value"
                :value="status.value"
              >
                {{ status.note }}
              </a-select-option>
            </a-select>
          </a-form-item>

          <a-form-item label="项目名称">
            <a-input-search
              v-model="queryParam.projectName"
              placeholder="请输入项目名称"
              style="width: 250px"
              @search="onSearch"
            />
          </a-form-item>

          <a-button type="primary" style="margin-top: 4px" @click="onSearch">
            查询
          </a-button>
          <a-button style="margin-left: 10px; margin-top: 4px" @click="reset">
            重置
          </a-button>
        </a-form>
      </div>

      <a-table
        :pagination="table.pagination"
        :loading="table.loading"
        :columns="table.columns"
        :data-source="table.data"
        rowKey="webId"
        :scroll="{ x: 1500 }"
        @change="handleTableChange"
      >
        <span slot="index" slot-scope="text, record, index">
          {{ (table.pagination.current - 1) * table.pagination.pageSize + index + 1 }}
        </span>

        <span slot="projectName" slot-scope="projectName, record">
          <a
            v-if="isProjectNameLink(record)"
            :href="record.shexgrpUrl"
            target="_blank"
            rel="noopener noreferrer"
          >
            {{ projectName }}
          </a>
          <span v-else>{{ projectName }}</span>
        </span>

        <span slot="rentCount" slot-scope="rentCount">
          {{ rentCount || "--" }}平方米
        </span>

        <span slot="projectStatus" slot-scope="projectStatus">
          {{ projectStatus | projectStatusText }}
        </span>

        <span slot="operation" slot-scope="text, record" class="operation-cell">
          <a @click="openIntentionPartyModal(record)">意向方信息</a>
        </span>
      </a-table>
    </a-card>

    <a-modal
      title="意向方信息"
      :width="980"
      :visible="intentionParty.visible"
      :footer="null"
      :destroyOnClose="true"
      @cancel="closeIntentionPartyModal"
    >
      <a-table
        :columns="intentionParty.columns"
        :data-source="intentionParty.data"
        :loading="intentionParty.loading"
        :pagination="intentionParty.pagination"
        rowKey="id"
        @change="handleIntentionPartyTableChange"
      />
      <div class="modal-footer-center">
        <a-button @click="closeIntentionPartyModal">关闭</a-button>
      </div>
    </a-modal>
  </div>
</template>


<script>
import {
  listIntentProjectPartyInfo,
  listPublishedIntentProject
} from "@/api/project/Project.js";

const projectStatusType = {
  20: "已公告",
  30: "已撤牌"
};

const projectStatusOptions = [
  { note: "全部", value: "" },
  ...Object.keys(projectStatusType).map((value) => ({
    note: projectStatusType[value],
    value
  }))
];

const columns = [
  { title: "序号", width: 80, align: "center", scopedSlots: { customRender: "index" } },
  {
    title: "项目名称",
    dataIndex: "projectName",
    width: 260,
    scopedSlots: { customRender: "projectName" }
  },
  { title: "项目编号", dataIndex: "webId", width: 210 },
  { title: "标的名称", dataIndex: "targetName", width: 260 },
  {
    title: "计租数量(租赁面积)",
    dataIndex: "rentCount",
    width: 210,
    scopedSlots: { customRender: "rentCount" }
  },
  {
    title: "项目状态",
    dataIndex: "projectStatus",
    width: 150,
    scopedSlots: { customRender: "projectStatus" }
  },
  { title: "招租公告起始日期", dataIndex: "projectStartTime", width: 190 },
  { title: "招租公告截止日期", dataIndex: "projectEndTime", width: 190 },
  {
    title: "操作",
    width: 140,
    fixed: "right",
    align: "center",
    scopedSlots: { customRender: "operation" }
  }
];

export default {
  data() {
    return {
      queryParam: {
        projectStatus: "",
        projectName: undefined
      },
      dictionaries: {
        projectStatus: projectStatusOptions
      },
      table: {
        loading: false,
        data: [],
        columns,
        pagination: {
          current: 1,
          pageNo: 1,
          pageSize: 10,
          total: 0,
          showTotal: (total) => `共 ${total} 条`
        }
      },
      intentionParty: {
        visible: false,
        loading: false,
        record: null,
        columns: [
          { title: "意向方名称", dataIndex: "partyName", align: "center" },
          { title: "手机号", dataIndex: "phone", align: "center" },
          { title: "备注", dataIndex: "remark", align: "center" }
        ],
        data: [],
        pagination: {
          current: 1,
          pageNo: 1,
          pageSize: 10,
          total: 0,
          showTotal: (total) => `共 ${total} 条`
        }
      }
    };
  },
  mounted() {
    this.getTableDetails();
  },
  filters: {
    projectStatusText(type) {
      return projectStatusType[type] || "--";
    }
  },
  methods: {
    onSearch() {
      this.getTableDetails({ page: 1 });
    },
    reset() {
      this.queryParam.projectStatus = "";
      this.queryParam.projectName = undefined;
      this.getTableDetails({ page: 1 });
    },
    handleTableChange(pagination) {
      this.getTableDetails({
        page: pagination.current,
        pageSize: pagination.pageSize
      });
    },
    getTableDetails(params = {}) {
      const page = params.page || this.table.pagination.current || 1;
      const pageSize = params.pageSize || this.table.pagination.pageSize || 10;
      const projectName = (this.queryParam.projectName || "").trim();

      this.table.loading = true;
      listPublishedIntentProject({
        page,
        pageSize,
        projectName,
        projectStatus: this.queryParam.projectStatus
      })
        .then((res) => {
          const pageData = this.normalizePageData(res);
          if (pageData.pageNo !== 1 && pageData.list.length === 0) {
            this.getTableDetails({ page: pageData.pageNo - 1, pageSize: pageData.pageSize });
            return;
          }

          this.table.data = pageData.list.map(this.normalizeProjectRow);
          this.table.pagination = {
            ...this.table.pagination,
            current: pageData.pageNo,
            pageNo: pageData.pageNo,
            pageSize: pageData.pageSize,
            total: pageData.total
          };
        })
        .catch((err) => {
          this.table.data = [];
          this.$notification["error"]({
            message: "查询失败",
            description: this.getErrorMessage(err)
          });
        })
        .finally(() => {
          this.table.loading = false;
        });
    },
    normalizePageData(res = {}) {
      const data = res.data || {};
      const list = Array.isArray(data.list)
        ? data.list
        : Array.isArray(res.data)
        ? res.data
        : [];

      return {
        list,
        total: Number(data.total || res.total || list.length || 0),
        pageNo: Number(data.pageNo || data.page || res.pageNo || res.current || 1),
        pageSize: Number(data.pageSize || res.pageSize || 10)
      };
    },
    normalizeProjectRow(record = {}) {
      return {
        ...record,
        targetName: record.targetName || record.projectName || "--",
        projectStartTime: record.projectStartTime || record.disclosureStartTime || "--",
        projectEndTime: record.projectEndTime || record.disclosureEndTime || "--",
        shexgrpUrl: record.shexgrpUrl || "--"
      };
    },
    isProjectNameLink(record) {
      return (
        Number(record.projectStatus) === 20 &&
        !!record.shexgrpUrl &&
        record.shexgrpUrl !== "--"
      );
    },
    openIntentionPartyModal(record) {
      this.intentionParty.record = record;
      this.intentionParty.visible = true;
      this.getIntentionPartyList({ page: 1 });
    },
    handleIntentionPartyTableChange(pagination) {
      this.getIntentionPartyList({
        page: pagination.current,
        pageSize: pagination.pageSize
      });
    },
    getIntentionPartyList(params = {}) {
      if (!this.intentionParty.record || !this.intentionParty.record.webId) {
        this.intentionParty.data = [];
        return;
      }

      const page = params.page || this.intentionParty.pagination.current || 1;
      const pageSize = params.pageSize || this.intentionParty.pagination.pageSize || 10;

      this.intentionParty.loading = true;
      listIntentProjectPartyInfo({
        webId: this.intentionParty.record.webId,
        page,
        pageSize
      })
        .then((res) => {
          const pageData = this.normalizePageData(res);
          if (pageData.pageNo !== 1 && pageData.list.length === 0) {
            this.getIntentionPartyList({
              page: pageData.pageNo - 1,
              pageSize: pageData.pageSize
            });
            return;
          }

          this.intentionParty.data = pageData.list.map((item) => ({
            ...item,
            remark: item.remark || "--"
          }));
          this.intentionParty.pagination = {
            ...this.intentionParty.pagination,
            current: pageData.pageNo,
            pageNo: pageData.pageNo,
            pageSize: pageData.pageSize,
            total: pageData.total
          };
        })
        .catch((err) => {
          this.intentionParty.data = [];
          this.$notification["error"]({
            message: "查询失败",
            description: this.getErrorMessage(err)
          });
        })
        .finally(() => {
          this.intentionParty.loading = false;
        });
    },
    closeIntentionPartyModal() {
      this.intentionParty.visible = false;
      this.intentionParty.record = null;
      this.intentionParty.data = [];
      this.intentionParty.pagination = {
        ...this.intentionParty.pagination,
        current: 1,
        pageNo: 1,
        total: 0
      };
    },
    getErrorMessage(err) {
      return (
        ((err.response || {}).data || {}).msg ||
        ((err.response || {}).data || {}).message ||
        err.msg ||
        err.message ||
        "网络异常，请稍后再试"
      );
    }
  }
};
</script>

<style scoped>
.my-lease {
  background-color: #fff;
  padding: 20px;
}

.search-area {
  margin-bottom: 20px;
}

a-form-item {
  margin-bottom: 15px;
}

/* 关键部分：修复输入框宽度异常 */
.search-area /deep/ .ant-input{
  width: 100% !important;
  height: 32px !important;
  padding: 4px 11px !important;
  border-radius: 4px !important;
  line-height: 1.5 !important;
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}

.operation-cell a {
  color: #1890ff;
  font-weight: 500;
}

.modal-footer-center {
  margin-top: 28px;
  text-align: center;
}

.modal-footer-center .ant-btn {
  min-width: 120px;
}
</style>
